import { z } from 'zod';

export const managedSecretsProviderEnum = z.enum(['ssm-parameter']);
export type ManagedSecretsProvider = z.infer<typeof managedSecretsProviderEnum>;

export const managedSecretsTableItemSchema = z.object({
  id: z.number(),
  name: z.string(),
  createdOn: z.coerce.date(),
  createdBy: z.object({
    id: z.number(),
    name: z.string(),
  }),
});

export const managedSecretSchema = z.object({
  id: z.number(),
  identifier: z.string(),
  name: z.string(),
  provider: managedSecretsProviderEnum,
  providerKey: z.string(),
});
export type ManagedSecret = z.infer<typeof managedSecretSchema>;

export const secretProviderSchema = z.enum(['secrets-manager']);
export type SecretsProviderType = z.infer<typeof secretProviderSchema>;